import React, { FC, ReactNode } from 'react'
import ProgressCircle from '@app/components/ProgressCircle'
import Progress from '@app/components/Progress'
import { useIntl } from 'react-intl'
import S from './QuizHeader.styles'

interface QuizHeaderProps {
  title: ReactNode
  intro: ReactNode
  nextStep: ReactNode
  progress: number
  step: number
}

const QuizHeader: FC<QuizHeaderProps> = ({ title, intro, nextStep, progress, step }) => {
  const { messages } = useIntl()

  return (
    <>
      <S.ProgressWrapper>
        <Progress
          value={progress}
          currentStep={step}
          steps={[
            { id: 1, title: messages['quiz_tracker.content.purchase_step.short_name'] as string },
            { id: 2, title: messages['quiz_tracker.content.valuation_step.short_name'] as string },
            { id: 3, title: messages['quiz_tracker.content.address_step.short_name'] as string },
            { id: 4, title: messages['quiz_tracker.content.payment_step.short_name'] as string },
          ]}
        />
      </S.ProgressWrapper>
      <S.Header>
        <div>
          <S.Title>{title}</S.Title>
          <S.Intro>{intro}</S.Intro>
          <S.NextStep>{nextStep}</S.NextStep>
        </div>
        {step > 0 && <ProgressCircle radius={50} strokeWidth={4} progress={progress} text={`${step} of 4`} />}
      </S.Header>
    </>
  )
}

export default QuizHeader
